import { Stack, Typography } from '@mui/material';

import { ApiWorkflowDialog, DialogMessageBox } from '@verantos-dev/shared-components';

import { useDeleteConceptGroupModal } from '../hooks/useDeleteConceptGroupModal';

export interface DeleteConceptGroupModalProps {
  isError?: boolean;
  isSuccess?: boolean;
  ConfirmationStepComponent?: React.ReactNode;
}

export const DeleteConceptGroupModal = () => {
  const {
    dialogMessages,
    contentMessages,
    isInUse,
    onClose,
    onSubmit,
    isSubmitting,
    isInitialLoading,
    deleteConceptGroupError,
    saveButtonColor,
    isValidForSubmit,
  } = useDeleteConceptGroupModal();

  return (
    <ApiWorkflowDialog
      id="deleteConceptGroupModal"
      title={contentMessages.title}
      onClose={onClose}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      dialogMessages={dialogMessages}
      saveButtonColor={saveButtonColor}
      submittingError={deleteConceptGroupError}
      isInitialLoading={isInitialLoading}
      isValidForSubmit={isValidForSubmit}
      hideDisplayButtonsOnSuccess
    >
      <DialogMessageBox
        id="delete-concept-group-message-box"
        title={isInUse ? contentMessages.inUseError : contentMessages.confirmTitle}
        type={isInUse ? 'warning' : 'error'}
        variant="outlined"
        renderSubmitted={
          !isInUse ? (
            <Stack gap={4}>
              <Typography color="error">{contentMessages.actionUndone}</Typography>
              <Typography>{contentMessages.description}</Typography>
            </Stack>
          ) : (
            <Typography>{contentMessages.inUseDescription}</Typography>
          )
        }
      ></DialogMessageBox>
    </ApiWorkflowDialog>
  );
};
